<template>
    <!-- Condition generale pour tous -->
    <h6 v-if="item.lms === true" class="notice mint">{{$t('INSCRIPTION EN COURS')}}</h6>
    <h6 v-else-if="formationStatus === 'désactivé'" class="notice" :class="item.deactivatedText && item.deactivatedText.toLowerCase() == 'inscription à venir' ? 'red' : 'red'">
        <span v-if="item.deactivatedText !== 'null'">{{ item.deactivatedText }}</span>
        <span v-else>{{$t('INSCRIPTION À VENIR')}}</span>
    </h6>
    <!-- Formation de création -->
    <h6 v-else-if="formationType === 'formation-de-creation' && formationStatus === 'active'" class="notice mint">{{$t('INSCRIPTION EN COURS')}}</h6>
    <h6 v-else-if="formationType === 'formation-de-creation' && formationStatus === 'inactive'" class="notice red">{{$t('INSCRIPTION À VENIR')}}</h6>
    <!-- Cours -->
    <h6 v-else-if="formationType === 'cours' && formationStatus === 'active'" class="notice mint">{{$t('INSCRIPTION EN COURS')}}</h6>
    <h6 v-else-if="formationType === 'cours' && formationStatus === 'complet'" class="notice red">{{$t('COMPLET')}}</h6>
</template>

<script>
export default {
    name: 'FormationStatusLabel',

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    computed: {
        formationType() {
            return this.item && this.item.formationType === 'creation' ? 'formation-de-creation' : 'cours'
        },
        formationStatus() {
            const currentDate = new Date().toISOString().slice(0, 10)

            if (!this.item || !this.formationType) {
                return 'loading'
            }

            if (this.item.deactivated) {
                return 'désactivé'
            }

            if (this.formationType === 'formation-de-creation') {
                return this.item.subscriptionDate >= currentDate && !this.item.deactivated ? 'active' : 'inactive'
            }

            if (this.formationType === 'cours') {

                if (this.item.startDate < currentDate) {
                    return 'complet'
                }

                if (this.item.startDate >= currentDate && !this.item.deactivated && !isNaN(parseInt(this.item.placeAvailable)) && parseInt(this.item.placeAvailable) <= 0) {
                    return 'complet'
                }

                if (this.item.startDate >= currentDate && !this.item.deactivated && !isNaN(parseInt(this.item.placeAvailable)) && parseInt(this.item.placeAvailable) > 0) {
                    return 'active'
                }
            }

            return 'loading'
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
